import { c as _c } from "react/compiler-runtime";
import type { SitePreviewData } from '@libs/common-next';
import css from './switch.module.scss';
type Props = {
  name: keyof SitePreviewData;
  value?: string | boolean;
  onChange: (key: keyof SitePreviewData, value: boolean) => void;
};
export function Switch(t0) {
  const $ = _c(10);
  const {
    name,
    value,
    onChange
  } = t0;
  const t1 = Boolean(value);
  let t2;
  if ($[0] !== name || $[1] !== onChange) {
    t2 = e => onChange(name, e.target.checked);
    $[0] = name;
    $[1] = onChange;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name || $[4] !== t1 || $[5] !== t2) {
    t3 = <input id={name} checked={t1} className={css.input} onChange={t2} type="checkbox" />;
    $[3] = name;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className={css.slider} />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <label className={css.toggle}>{t3}{t4}</label>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}